$(".newTimelineMf").on("init", function () {
    if ($(window).width() >= 990) {
  $(`.newTimelineMfItem.slick-current .newTimelineMfItemImage,
.newTimelineMfItem.slick-current .newTimelineMfItemTitle,
.newTimelineMfItem.slick-current .newTimelineMfItemContentContent`).fadeIn();
    }
});
$(".newTimelineMf").slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  centerMode: true,
  variableWidth: true,
  nextArrow: $(".newTimelineMfNext"),
  prevArrow: $(".newTimelineMfPrev"),
  adaptiveHeight: true,
  initialSlide: selectedVintageIndex,
});
$(".newTimelineMf").on("click", ".slick-slide", function (e) {
  e.stopPropagation();
  var index = $(this).data("slick-index");
  if ($(".slick-slider").slick("slickCurrentSlide") !== index) {
    $(".slick-slider").slick("slickGoTo", index);
  }
});
$(".newTimelineMf").on(
  "beforeChange",
  function (event, slick, currentSlide, nextSlide) {
    if ($(window).width() >= 990) {
      $(`.newTimelineMfItem[data-slick-index='${currentSlide}'] .newTimelineMfItemImage,
  .newTimelineMfItem[data-slick-index='${currentSlide}'] .newTimelineMfItemTitle,
  .newTimelineMfItem[data-slick-index='${currentSlide}'] .newTimelineMfItemContentContent,
  .newTimelineMfItem[data-slick-index='${currentSlide}'] .newTimelineMfItemContentVintage2,
  .newTimelineMfItem[data-slick-index='${nextSlide}'] .newTimelineMfItemContentVintage2 `).hide();
    }
  }
);
$(".newTimelineMf").on(
  "afterChange",
  function (event, slick, currentSlide, nextSlide) {
    if ($(window).width() >= 990) {
      setTimeout(function () {
        $(`.newTimelineMfItem[data-slick-index='${currentSlide}'] .newTimelineMfItemImage,
.newTimelineMfItem[data-slick-index='${currentSlide}'] .newTimelineMfItemTitle,
.newTimelineMfItem[data-slick-index='${currentSlide}'] .newTimelineMfItemContentContent,
.newTimelineMfItem[data-slick-index='${currentSlide}'] .newTimelineMfItemContentVintage2`).fadeIn();
      }, 100);
    }
  }
);
